module.exports = __webpack_public_path__ + "static/edit-home1-3-banners-dd0d780171dc7b1c9a03678607130389.png";